import breakTo from '../../styles/tools/breakTo'
import { unit, number, important } from '../tools/parsers'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const inputWidth = {
    default: `${number(spacings.default) * 42}${unit(spacings.default)}`,
    x2: `${number(spacings.default) * 42 * 2}${unit(spacings.default)}`
  }

  const keyframes = {
    blink: {
      to: {
        borderBottom: `2px solid ${colors.input.border.default}`
      }
    }
  }

  const styles = {
    component: {
      position: 'relative',
      display: 'inline-block',
      width: '100%',
      padding: `${spacings.x2} ${spacings.default} ${spacings.default}`,
      margin: `${spacings.x2} 0 ${spacings.x2} 0`,

      ':nth-child(odd)': {
        marginLeft: '0'
      },

      ':nth-child(even)': {
        marginRight: '0'
      },

      [breakTo('small')]: {
        width: inputWidth.default,
        //margin: `${spacings.x4} ${spacings.x2} ${spacings.x4} 0`,

        ':nth-child(even) + :last-child': {
          width: '100%',
          maxWidth: `${number(inputWidth.x2) + number(spacings.x2)}${unit(
            inputWidth.default
          )}`,
          marginRight: '0'
        },

        ':only-child': {
          width: '100%',
          maxWidth: `${number(inputWidth.x2) + number(spacings.x2)}${unit(
            inputWidth.default
          )}`,
          marginRight: '0'
        }
      }
    },

    'component--block': {
      maxWidth: important(
        `${number(inputWidth.x2) + number(spacings.x2)}${unit(
          inputWidth.default
        )}`
      ),
      width: important('100%'),
      marginRight: important('0')
    },

    'component--third': {
      maxWidth: `${number(inputWidth.x2) + number(spacings.x2)}${unit(
        inputWidth.default
      )}`,
      width: '100%',
      marginRight: '0',

      [breakTo('small')]: {
        width: `${(number(inputWidth.x2) + number(spacings.x2)) / 3}${unit(
          inputWidth.default
        )}`,
        marginRight: '0'
      }
    },

    'component--hidden': {
      display: 'none'
    },

    'component--bare': {
      margin: '0',
      padding: '0',

      ':nth-child(odd)': {
        marginRight: spacings.x2
      }
    },

    label: {
      fontSize: '1.125rem',
      fontWeight: fontWeights.label.default,

      position: 'absolute',

      display: 'none',
      visibility: 'hidden',

      color: colors.label.default
    },

    'label--active': {
      fontSize: '.75rem',

      top: '0',

      display: 'block',
      visibility: 'visible'
    },

    'label--required': {
      color: colors.common.utility.error.default
    },

    'label--error': {
      color: colors.common.utility.error.default
    },

    'label--neutral': {
      color: important(colors.common.body.bg.default)
    },

    option: {
      color: colors.input.text.default
    },

    input: {
      fontFamily: fontFamilies.default,
      fontWeight: fontWeights.input.default,
      fontSize: fontSizes.input.default,
      textIndent: fontSizes.input.textIndent,
      lineHeight: fontSizes.input.lineHeight,

      boxSizing: 'border-box',
      width: '100%',
      paddingTop: spacings.input.padding.top.default,
      paddingLeft: '.3rem',
      paddingBottom: '.5rem',
      backgroundColor: colors.input.bg.default,
      borderRadius: '0',
      borderTop: '0',
      borderRight: '0',
      borderBottom: `2px solid ${colors.input.border.default}`,
      borderLeft: '0',
      borderImageSource: 'initial',
      borderImageSlice: 'initial',
      borderImageWidth: 'initial',
      borderImageOutset: 'initial',
      borderImageRepeat: 'initial',

      color: colors.input.text.default,

      ':disabled': {
        color: colors.input.text.disabled,
        backgroundColor: colors.input.bg.default,
        // borderBottom: `2px solid ${colors.input.border.default}`,
        // paddingLeft: 0,
        backgroundImage: 'none',
        cursor: 'not-allowed'
      },

      ':disabled + span': {
        color: colors.label.disabled
      },

      '::input-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },

      '::-webkit-input-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },
      '::-moz-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },
      /* firefox 19+ */
      ':-ms-input-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },
      /* ie */
      ':-moz-placeholder': {
        color: colors.label.disabled,
        textTransform: textTransforms.input.placeholder
      },

      ':active': {
        borderBottom: `2px solid ${colors.input.border.active}`,
        outline: 'none'
      },

      ':focus': {
        borderBottom: `2px solid ${colors.input.border.active}`,
        outline: 'none'
      }
    },

    'input--focused': {
      borderBottom: `2px solid ${colors.input.border.active}`
    },

    'input--invalid': {
      borderBottom: `2px solid ${colors.common.utility.error.default}`,

      ':not(:active) ~ span': {
        color: colors.common.utility.error.default
      },

      ':active ~ span': {
        color: colors.label.default
      },

      ':active ~ small': {
        display: 'none'
      },

      ':focus ~ span': {
        color: colors.label.default
      },
      ':focus ~ small': {
        display: 'none'
      }
    },

    'input--select': {
      background: images.selectTriangle
    },

    'input--unset': {
      color: important(colors.input.placeholder.default)
    },

    'input--blink': {
      animationName: keyframes.blink,
      animationDuration: '1s',
      animationTimingFunction: 'steps(5, start)',
      animationIterationCount: 'infinite',

      borderBottom: `2px solid ${colors.input.border.blink}`,
      outline: 'none'
    },

    'error-msg': {
      position: 'absolute',

      display: 'block',

      marginTop: spacings.default,

      fontSize: '.75rem',
      fontWeight: fontWeights.input.error,

      color: colors.common.utility.error.default
    },
    hint: {
      position: 'absolute',

      display: 'block',

      marginTop: spacings.default,

      fontSize: '.75rem',
      fontWeight: fontWeights.input.error,

      color: important(colors.common.body.text.default)
    },
    singleField: {
      width: '100%!important',
      maxWidth: `${number(inputWidth.x2) + number(spacings.x2)}${unit(
        inputWidth.default
      )}`,
      marginRight: '0'
    },
    divPrefix:{
      width: '20%!important',
      maxWidth: `${number(inputWidth.x2) + number(spacings.x2)}${unit(
        inputWidth.default
      )}`,
      marginRight: '0',
      verticalAlign: 'top',
      marginTop: '58px'
    },
  }

  return styles
}



// WEBPACK FOOTER //
// ./styles/objects/component.js